export default "__VITE_ASSET__CLyEp5L$__"